export type Notification = {
	id: string;
	content?: React.ReactElement;
};

export type NotificationManagerReducerAction = {
	type: 'ADD_NOTIFICATION' | 'REMOVE_NOTIFICATION' | 'CLEAR_NOTIFICATIONS';
	payload: Notification;
};

export function NotificationManagerReducer(notifications: Notification[], action: NotificationManagerReducerAction) {
	switch (action.type) {
		case 'ADD_NOTIFICATION':
			return [...notifications, action.payload];
		case 'REMOVE_NOTIFICATION':
			return notifications.filter((n) => n.id !== action.payload.id);
		case 'CLEAR_NOTIFICATIONS':
			return [];
		default:
			return notifications;
	}
}
